import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

// Local components
import APPDATA from "./APPDATA.js";
import Loading from "./Loading.js";

// Content Pages
import Header from "../content/pages/Header.js";
import Footer from "../content/pages/Footer.js";
import Home from "../content/pages/_Home.js";
import Gallery from "../content/pages/Gallery.js";

// Data

// CSS
import "../content/pages/_general.css";

//-------------------------------------------------
document.title = APPDATA.TITLE;
//-------------------------------------------------

const App = ({ rootBase }) => {
  // eslint-disable-next-line no-unused-vars
  const [currentUser, setCurrentUser] = useState({});
  const [loading, setLoading] = useState("");

  const routes = [
    { route: "Home", path: ".#home" },
    { route: "About", path: ".#about" },
    { route: "Premium", path: ".#premium" },
    { route: "Gallery", path: "gallery", element: <Gallery APPDATA={APPDATA} /> },
    { route: "Why us", path: ".#why" },
    { route: "Contact", path: ".#contact" }
  ];

  useEffect(() => { }, [loading]); //  to re-render when any loading event occurs

  useEffect(() => { //loading
    setLoading("Loading ...");
    setCurrentUser(JSON.parse(sessionStorage.getItem("currentUser")));
    sessionStorage.setItem("APPDATA", JSON.stringify(APPDATA));
    // window.scrollTo(0, 0);    
    setLoading("");
    return () => {
      sessionStorage.clear();
      localStorage.clear();
    };
  }, []);

  return (
    <>
      <div id="home"></div>
      <Header APPDATA={APPDATA} routes={routes} />
      {loading ? (
        <Loading text={loading} />
      ) : (
        <>
          <Routes>
            <Route path="/" exact element={<Home APPDATA={APPDATA} />} />
            {routes.map(r => {
              return (
                <Route key={r.route}
                  path={r.path}
                  exact
                  element={
                    r.element || `<${r.route[0].toUpperCase() + r.route.slice(1)} APPDATA={APPDATA} />`}
                />
              );
            })}
            <Route
              path="/*"
              element={
                <div
                  style={{
                    margin: "8rem",
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  🤫 Page Not Found!
                </div>
              }
            />
          </Routes>
        </>
      )}
      <Footer APPDATA={APPDATA} />
      {/* force importing modules:   ??? */}
      {/* {false ? <Gallery /> : null} */}
    </>
  );
}

export default App;
